<template>

    <div class="fan-control">
        <div class="status">
            <el-button plain type="primary" @click="connectDevice" v-if="!connected" size="small">连接设备</el-button>
            <el-button plain type="danger" @click="disconnectDevice" v-if="connected" size="small">断开连接</el-button> 
            <el-button plain type="danger" @click="auth" v-if="connected" size="small">验证</el-button> 
            <el-input
                v-model="rxData"
                style="width: 480px"
                :rows="10"
                
                readonly
                type="textarea"                
                clearable
            />            
           
        </div>
        <div>
            <el-input
                v-model="txData"
                style="width: 240px"
                placeholder="HEX"
                clearable
            />
            <el-button plain type="danger" @click="send" v-if="connected" size="small">发送</el-button> 
        </div>
    </div>

</template>
<script setup>
  import { ref, reactive, computed, onMounted } from 'vue'
  import { stringToBuffer,arrayBuffer2hex,hexToArrayBuffer} from '@/utils/hex.ts'
//   import { ElMessage } from 'element-plus'
  
  function arrayBufferToString(buffer, encoding = 'utf-8') {
    const decoder = new TextDecoder(encoding);
    const uint8Array = new Uint8Array(buffer);
    return decoder.decode(uint8Array);
}

const connected = ref(false)
const device = ref(null)

const serviceUUID = '0000FFF0-0000-1000-8000-00805F9B34FB'.toLowerCase() // 默认心率服务
const char1UUID = '0000FFF1-0000-1000-8000-00805F9B34FB'.toLowerCase()
// 新增状态变量
const char2UUID = '0000FFF2-0000-1000-8000-00805F9B34FB'.toLowerCase() 

let server = null
let service = null 
let chart1 = null
let chart2 = null
const rxData = ref('')
const txData = ref('')
const command = ref('')
// const logs = reactive([])

const deviceInfo = reactive({
  name: '',
  id: ''
})

// 计算属性
//const connectionStatus = computed(() => connected.value ? '已连接' : '未连接')
//const canSend = computed(() => command.value.trim() !== '')

// 日志记录
const addLog = (message) => {
    console.log(message)
}

// 在handleNotifications中添加格式选择
const handleNotifications = (event) => {

  const value = event.target.value
 rxData.value+=arrayBufferToString(value.buffer)
  
  //let data = arrayBuffer2hex(value.buffer)
  //console.log('recv data',data)
  //rxData.value+=data+'\r\n'
  //let json = JSON.parse(data)  
  //console.log('json',data)
 // addLog(`收到数据: ${data}`)
}

// 新增启用通知方法
const startNotifications = async () => {
  try {
  
    chart1.addEventListener('characteristicvaluechanged', handleNotifications)
    await chart1.startNotifications()
    
   
    addLog('通知功能已启用')
  } catch (error) {
    addLog(`启用通知失败: ${error}`)
  }
}

// 连接设备
const connectDevice = async () => {
  try {
    device.value = await navigator.bluetooth.requestDevice({
      acceptAllDevices: false,    
      optionalServices: [serviceUUID],
      filters: [ 
        { namePrefix: 'KLY_' } 
      ]
    })
    
    deviceInfo.name = device.value.name
    deviceInfo.id = device.value.id
    
    device.value.addEventListener('gattserverdisconnected', disconnectHandler)
    
    server = await device.value.gatt.connect()
    connected.value = true
    addLog(`已连接至设备: ${device.value.name}`)

    service = await server.getPrimaryService(serviceUUID)
    console.log('service',service)
    chart1 = await service.getCharacteristic(char1UUID)
    console.log('ch1',chart1)
    chart2 = await service.getCharacteristic(char2UUID)
    console.log('ch2',chart2)
    console.log('start',service,chart1,chart2)
    startNotifications()

  } catch (error) {
    addLog(`连接失败: ${error}`)
  }
}

// 断开连接处理
const disconnectHandler = () => {
  connected.value = false
  deviceInfo.name = ''
  deviceInfo.id = ''
  addLog('设备已断开连接')
}

// 主动断开连接
const disconnectDevice = () => {
  if (device.value?.gatt.connected) {
    device.value.gatt.disconnect()
  }
  connected.value = false
}

const auth = ()=>{
   
    const data = stringToBuffer('FA5685E8')    
    chart2.writeValue(data)
    console.log('auth')
    
}
const send = ()=>{
    if(txData.value){
         const data = hexToArrayBuffer(txData.value)    
         chart2.writeValue(data)
         console.log('send')
    }
}

// 发送命令
const sendCommand = async () => {
//   try {   
//     // 将命令转换为ArrayBuffer
//     const data = hexStringToArrayBuffer(command.value.trim())    
//     await dutyChar.writeValue(data)
//     addLog(`命令已发送: ${command.value}`)
//     command.value = ''
//   } catch (error) {
//     addLog(`发送失败: ${error}`)
//   }
}

// 十六进制字符串转ArrayBuffer
const hexStringToArrayBuffer = (hex) => {
  hex = hex.replace(/\s/g, '')
  if (hex.length % 2 !== 0) throw new Error('无效的十六进制字符串')
  
  const buffer = new Uint8Array(hex.length / 2)
  for (let i = 0; i < hex.length; i += 2) {
    buffer[i/2] = parseInt(hex.substr(i, 2), 16)
  }
  return buffer
}

onMounted(()=>{
    
})
</script>
<style>
.device-info{
    width: 90%;
}

.fan-control {
  max-width: 700px;
  margin: 2rem auto;
  padding: 20px;
  background: #f5f5f5;
  border-radius: 10px;
  text-align: center;
}

.status {
  display: flex;
  justify-content: space-around;
  margin-bottom: 20px;
}

.status-item {
  font-size: 1.2em;
}

.fan-container {
  position: relative;
  width: 200px;
  height: 200px;
  margin: 20px auto;
}

.fan {
  width: 100%;
  height: 100%;
  position: relative;
  transition: filter 0.3s;
}

.blade {
  position: absolute;
  width: 40px;
  height: 100px;
  background: #607D8B;
  left: 50%;
  transform-origin: bottom;
  border-radius: 10px;
}

.blade:nth-child(1) { transform: translateX(-50%) rotate(0deg); }
.blade:nth-child(2) { transform: translateX(-50%) rotate(120deg); }
.blade:nth-child(3) { transform: translateX(-50%) rotate(240deg); }

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.controls {
  margin-top: 20px;
}

input[type="range"] {
  width: 80%;
  height: 10px;
  background: #ddd;
  border-radius: 5px;
}

.speed-percent {
  font-size: 1.5em;
  margin-top: 10px;
  color: #2196F3;
}


</style>s